import { TaxSystem } from "adminPanel/settings/settingTaxes/ITaxSystem";
import { useAppSelector } from "app/hooks";
import { store } from "app/store";

export const IsTaxDisable = (): boolean => {
  return useAppSelector(
    (s) => s.organizationSettings.taxState.system === TaxSystem.NotSelected,
  );
};

export const IsTaxEnabled = (): boolean => {
  return useAppSelector(
    (s) => s.organizationSettings.taxState.system !== TaxSystem.NotSelected,
  );
};

export function getIsEgyptianTaxEnabled(): boolean {
  return (
    store.getState().organizationSettings.taxState.system === TaxSystem.Egypt
  );
}

export const IsEgyptianTaxEnable = (): boolean => {
  return useAppSelector(
    (s) => s.organizationSettings.taxState.system === TaxSystem.Egypt,
  );
};

export const IsEmiratesTaxEnable = (): boolean => {
  return useAppSelector(
    (s) => s.organizationSettings.taxState.system === TaxSystem.Emirates,
  );
};

export const IsSyrianTaxEnable = (): boolean => {
  return useAppSelector(
    (s) => s.organizationSettings.taxState.system === TaxSystem.Syria,
  );
};

export function getIsSyrianTaxEnabled(): boolean {
  return (
    store.getState().organizationSettings.taxState.system === TaxSystem.Syria
  );
}

export function getEGPTaxItemsCount(ticketItems: any[]): number {
  if (!ticketItems || ticketItems.length === 0) return 0;

  return ticketItems.length;
}

export function isEGPTaxItemLimitExceeded(ticketItems: any[]): boolean {
  return getEGPTaxItemsCount(ticketItems) >= 300;
}
